import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { LegalFooter } from "@/components/LegalFooter";

const Block = ({ item }) =>
  Array.isArray(item) ? (
    <ul className="list-disc pl-6 space-y-2">
      {item.map((li) => <li key={li}>{li}</li>)}
    </ul>
  ) : (
    <p>{item}</p>
  );

export default function LegalPage({ doc }) {
  const { user } = useAuth();
  useEffect(() => window.scrollTo(0, 0), [doc.id]);
  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid={`${doc.id}-page`}>
      <header className="border-b border-slate-200/80 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
          <Logo />
          <Link to={user ? "/dashboard" : "/login"} className="flex items-center gap-2 text-sm font-semibold text-slate-600 hover:text-slate-900" data-testid="legal-back-link">
            <ArrowLeft className="w-4 h-4" /> {user ? "Back to app" : "Back to login"}
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-10 sm:py-14">
        <article className="mt-card p-6 sm:p-10 text-slate-700 leading-relaxed text-sm sm:text-base">
          <p className="mt-overline">Legal</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 mt-2" data-testid="legal-title">{doc.title}</h1>
          <p className="text-sm text-slate-500 mt-3" data-testid="legal-effective-date">Effective date: {doc.effective}</p>
          <p className="mt-6">{doc.intro}</p>
          {doc.sections.map((s) => (
            <section key={s.h} className="mt-8 space-y-3">
              <h2 className="font-heading text-base md:text-lg font-bold text-slate-900">{s.h}</h2>
              {s.body.map((item, i) => <Block key={i} item={item} />)}
            </section>
          ))}
        </article>
        <LegalFooter className="mt-8" />
      </main>
    </div>
  );
}
